import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { userLogout, changeUserSeason } from '../actions/userActions.js';
import Navbar from '../components/Navbar';

const mapDispatchToProps = dispatch => {
  return {
    handleLogout: () => {
      dispatch(userLogout());
    },
    changeUserSeason: (userSeason) => {
      dispatch(changeUserSeason(userSeason));
    }
  };
};
const mapStateToProps = state => {
  return {
    userName: state.user.userName,
    userType: state.user.userType,
    seasons: state.seasons.seasons,
    seasonsList: state.seasons.seasonsList,
    userSeason: state.user.userSeason
  };
};

const NavbarContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));
export default NavbarContainer;



// WEBPACK FOOTER //
// ./src/containers/NavbarContainer.js